export default __webpack_public_path__ + "static/media/pic2.20696db9.jpg";